import React, { useState } from "react";
import colors from "../styles/colors";
import { useTranslation } from "react-i18next";

interface WindowProfile {
  type: string;
  profileDimensions: string;
  visibleWidth: string;
  thermalInsulation: string;
}

interface SectionTableProps {
  title: string;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  // sectionTableImages: string[];
  windowProfiles: WindowProfile[];
}

const SectionTable: React.FC<SectionTableProps> = ({
  title,
  activeTab,
  setActiveTab,
  // sectionTableImages,
  windowProfiles,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  // const [currentImage, setCurrentImage] = useState("");

  // useEffect(() => {
  //   const newImage =
  //     sectionTableImages[
  //       windowProfiles.findIndex((profile) => profile.type === activeTab)
  //     ];
  //   setCurrentImage(newImage);
  //   setLoading(true);
  // }, [activeTab, sectionTableImages, windowProfiles]);

  return (
    <div
      className="w-full min-h-[60vh] font-serif px-6 py-12 md:px-12 md:py-16 flex flex-col items-center text-center space-y-6"
      style={{ backgroundColor: colors.pastelCream, color: colors.darkBrown }}
    >
      <h2 className="text-3xl md:text-4xl lg:text-5xl text-primaryGreen tracking-wide">
        {title}
      </h2>

      {/* Tab Bar */}
      <div className="flex flex-wrap justify-center gap-4">
        {windowProfiles.map((profile) => (
          <button
            key={profile.type}
            onClick={() => setActiveTab(profile.type)}
            className={`px-4 py-2 md:px-6 md:py-3 rounded-full transition-all duration-300 text-sm md:text-lg
            ${
              activeTab === profile.type
                ? "text-white shadow-lg transform scale-105"
                : "bg-gray-200 text-primaryGreen hover:bg-gray-300"
            }`}
            style={{
              backgroundColor:
                activeTab === profile.type
                  ? colors.primaryGreen
                  : colors.pastelCream,
            }}
          >
            {profile.type} {t("wooden.table.profile")}
          </button>
        ))}
      </div>

      {/* Responsive Content Container */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-center mt-6">
        {/* Image Container */}
        <div className="w-full flex justify-center mt-4">
          <div className="relative w-full max-w-md md:max-w-lg lg:max-w-2xl">
            {loading && (
              <div
                className="absolute inset-0 flex items-center justify-center bg-opacity-80"
                style={{ backgroundColor: colors.pastelCream }}
              >
                <div className="loader w-12 h-12 border-4 border-black border-t-transparent rounded-full animate-spin"></div>
              </div>
            )}
            {/* {sectionTableImages.length > 0 && ( */}
              <img
                src="/assets/images/img_placeholder.jpg"
                loading="lazy"
                alt={`${activeTab} SectionTable`}
                className="w-full h-auto max-h-[70vh] object-cover rounded-lg shadow-lg"
                onLoad={() => setLoading(false)}
              />
            {/* )} */}
          </div>
        </div>

        {/* Table + Documentation Button */}
        <div
          className="w-full font-serif max-w-lg mx-auto"
          style={{ color: colors.darkBrown }}
        >
          <table className="w-full text-sm md:text-lg leading-relaxed border-separate border-spacing-y-3">
            <tbody>
              {windowProfiles
                .filter((profile) => profile.type === activeTab)
                .map((profile) => (
                  <>
                    <tr>
                      <td className="font-semibold py-2 px-4">
                        {t("wooden.table.profileDimensions")}
                      </td>
                      <td className="px-4 text-left">
                        {profile.profileDimensions}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-semibold py-2 px-4">
                        {t("wooden.table.visibleWidth")}
                      </td>
                      <td className="px-4 text-left">{profile.visibleWidth}</td>
                    </tr>
                    <tr>
                      <td className="font-semibold py-2 px-4">
                        {t("wooden.table.thermalInsulation")}
                      </td>
                      <td className="px-4 text-left">
                        {profile.thermalInsulation}
                      </td>
                    </tr>
                  </>
                ))}
            </tbody>
          </table>

          {/* Open SectionTable documentation link */}
          <div className="mt-6 flex justify-center">
            <button
              className="px-5 py-2 border rounded-lg transition-all duration-300"
              style={{
                backgroundColor: colors.darkBrown,
                color: colors.lightCream,
                borderColor: colors.darkBrown,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = colors.pastelCream;
                e.currentTarget.style.color = colors.darkBrown;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = colors.darkBrown;
                e.currentTarget.style.color = colors.pastelCream;
              }}
              onClick={() => {
                // const profileType = activeTab;
                // let pdfUrl = "";

                // if (profileType === "71") {
                //   pdfUrl = "/assets/SectionTables/szekcio_fa_ablak_71.pdf";
                // } else if (profileType === "90-92") {
                //   pdfUrl = "/assets/SectionTables/szekcio_fa_ablak_90.pdf";
                // } else if (profileType === "110") {
                //   pdfUrl = "/assets/SectionTables/szekcio_fa_ablak_110.pdf";
                // }

                // if (pdfUrl) {
                //   window.open(pdfUrl, "_blank");
                // } else {
                  alert("No documentation available at the moment.");
                //}
              }}
            >
              {t("wooden.table.profileButton")}
            </button>
          </div>
        </div>
      </div>
       {/* Horizontal Divider */}
       <div
        className="w-full max-h-[20vh] pt-24 pb-24 flex justify-center"
        style={{ backgroundColor: colors.pastelCream }}
      >
        <hr
          className="w-[23%] sm:w-[15%] md:w-[15%] lg:w-[10%] h-0.5 border-t-0 opacity-100 dark:opacity-80"
          style={{ backgroundColor: colors.darkBrown }}
        />
      </div>
    </div>
  );
};

export default SectionTable;
